module.exports = __webpack_public_path__ + "static/media/signaporeBusiness.d5221ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/signaporeBusiness.png
// module id = 1817
// module chunks = 146